if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        const reaMinicart = document.getElementById('rea-minicart');
        this.cart =
          reaMinicart ||
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.isReaMinicartTarget = this.cart?.id === 'rea-minicart';
        this.submitButton = this.querySelector('[type="submit"]');

        const opensDialog =
          this.cart?.matches('cart-drawer') ||
          (this.isReaMinicartTarget && this.dataset.pwwContext !== 'minicart');

        if (opensDialog) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        let addToken = null;

        // REA must freeze its baseline before the add; legacy targets start fetch immediately.
        const addRequest =
          this.isReaMinicartTarget && typeof this.cart.beginAddOperation === 'function'
            ? this.cart
                .beginAddOperation(this.dataset.pwwContext === 'minicart' ? 'pww' : 'pdp')
                .then((token) => {
                  addToken = token;
                  return fetch(`${routes.cart_add_url}`, config);
                })
            : fetch(`${routes.cart_add_url}`, config);

        addRequest
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.releaseReaAddOperation(addToken);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              // if (typeof response.description === 'string' && response.description.startsWith('All') && response.description.endsWith('are in your cart.')) {
              //   window.location = window.routes.cart_url;
              //   return;
              // }

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.releaseReaAddOperation(addToken);
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              const pubObj = {
                source: 'product-form',
                productVariantId: formData.get('id'),
                productVariantQuantity: formData.get('quantity'),
                cartData: response,
              };
              if (this.dataset.pwwContext) {
                pubObj.pwwContext = this.dataset.pwwContext;
              }
              publish(PUB_SUB_EVENTS.addToCart, pubObj);
              publish(PUB_SUB_EVENTS.cartUpdate, pubObj);
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response, addToken);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response, addToken);
            }
            /*             setTimeout(() => {
                          window.location.href = window.routes.cart_url;
                        }); */
          })
          .catch((e) => {
            this.releaseReaAddOperation(addToken, true);
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /**
       * Releases a REA Minicart add operation that will never reach renderContents.
       * @param {number|null} token
       * @param {boolean} [cartStateUncertain=false]
       */
      releaseReaAddOperation(token, cartStateUncertain = false) {
        if (token != null) this.cart.abortAddOperation(token, cartStateUncertain);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
